$(document).ready(function() { 

  if (typeof window_customer != 'undefined') {
    var address = window_customer;
  }
  $('select.addressField').on('change', function (e) {
    $('.addnetterm').removeClass("selected_button_add");
    $('.address_edit_form_ajax').find('.error_msg').remove(); 
    var button_address = $(this).find(':selected').attr('data-id');
    var take_address = $(address).filter(function(index, cont) {                    
      if(cont.id != null){
        return cont.id == button_address;
      }
    });
    $('.addressadd_term .form-field').each(function(j, k) {
      var data = $(k).find('.form-field-input').data('add');
      if (take_address.length > 0) {
        $(k).find('.form-field-input').val(take_address[0][data]).trigger('click');
        $('.shipping_step').find('#address_zip_new').val(take_address[0]['zip']);
        if (take_address[0]['province'] == null) {
          $(k).find('.form-field-input[data-add="province"]').prop("selectedIndex", 0);
          $('.shipping_step').find('#address_province_new').prop("selectedIndex", 0);
        } else {
          $('.shipping_step').find('#address_province_new').val(take_address[0]['province']);
        }
      } else {
        $(k).find('input.form-field-input').val('');
        $(k).find('select.form-field-input').prop("selectedIndex", 0);
        $('.shipping_step').find('#address_province_new').prop("selectedIndex", 0);
        $('.shipping_step').find('#address_zip_new').val('');
      }
    });
  });

  function cartUpdate() {
    $.ajax({
      type: "GET",
      url: "/cart/update.js?csapp=aiod",
      data: $('.cart-form').serialize(),
      dataType: "json",
      success : function(data) { 
        $.getJSON('/cart.js?csapp=aiod', function(cart) {
          console.log(cart);
          window.update_cart_data = cart;
        });
      }
    });
  }

  $("body").on("click",'.normal_checkout',function(e) {
    e.preventDefault();
    recent_click = 'normal_checkout';
  });
  $("body").on("click",'.netterm_customer',function(e) {
    e.preventDefault();
    recent_click = 'netterm_customer';
    $(".netterm_tag").addClass("popup-active");	
    $(".netterm_tag").removeClass("error_msg_dis");	
    $('.overlay').addClass("popup-active");
    $("body").addClass("overflow_hidden");
    if (AIOD_discount) {
      setTimeout(function () {
        $('.netterm_submit').removeAttr('disabled');
        $('.netterm_submit').removeClass('processing');
      }, 3000);
    } else {
      $('.netterm_submit').removeAttr('disabled');
      $('.netterm_submit').removeClass('processing');
    }
    cartUpdate();
  });

  if($(".popup-active").length > 0){
    $("body").addClass("overflow_hidden");
  }


  $('#contact_form').submit( function() {
    var form = $(this);
    var x = true;
    var em = form.find('#ContactFormEmail');
    var masg = form.find('#ContactFormMessage');
    form.find('.error_msg').remove();  
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      $(em).parent().append('<span class="error_msg">Contact e-mail required</span>');
      em.css({'border-bottom':'1px solid red'});
      x = false;
    } else{
      em.css({'border-bottom':'1px solid #e5e5e5'});	
    }
    if(masg.val().trim() == '') {
      $(masg).parent().append('<span class="error_msg">Contact Message required</span>');
      masg.css({'border-bottom':'1px solid red'});
      x = false;
    } else{
      masg.css({'border-bottom':'1px solid #e5e5e5'});	
    }
    if(x == false){
      return false;
    }
  });

  $('body').on('submit','.address_edit_form_ajax', function(e){
    e.preventDefault();
    var x = true;
    var zip = $(this).find('.form-field-input[name="address[zip]"]');
    var f_name = $(this).find('.form-field-input[name="address[first_name]"]');
    var l_name = $(this).find('.form-field-input[name="address[last_name]"]');
    var add_1 = $(this).find('.form-field-input[name="address[address1]"]');
    var city = $(this).find('.form-field-input[name="address[city]"]');
    var email = $(this).find('.form-field-input[name="address[email]"]');
    var phone = $(this).find('.form-field-input[name="address[phone]"]');
    var reg = new RegExp('^[0-9]*$');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    $(this).find('.error_msg').remove(); 
    if(email.val().trim() == '' || !regex.test(email.val())) {
      $(email).parent().append('<span class="error_msg">This field is required</span>');
      x = false;
    }
    if(f_name.val().trim() == '') {
      $(f_name).parent().append('<span class="error_msg">This field is required</span>');
      x = false;
    }
    if(l_name.val().trim() == '') {
      $(l_name).parent().append('<span class="error_msg">This field is required</span>');
      x = false;
    }
    if(add_1.val().trim() == '') {
      $(add_1).parent().append('<span class="error_msg">This field is required</span>');
      x = false;
    }
    if(city.val().trim() == '') {
      $(city).parent().append('<span class="error_msg">This field is required</span>');
      x = false;
    }
    if(zip.val().trim() == '') {
      $(zip).parent().append('<span class="error_msg">This field is required</span>');
      x = false;
    }
    if(phone.val().trim() == '' || !reg.test(phone.val())) {
      $(phone).parent().append('<span class="error_msg">This field is required</span>');
      x = false;
    }
    if(x == false){
      return false;
    }
    $('.get-rates_new').trigger('click');
  });

  $('#cart_note_leave').on("change", function(e) {    
    //     if ($(this).is(':checked')) {
    //       $(this).attr('value', 'Yes');
    //     } else {
    //       $(this).attr('value','No');
    //     }
    //     cartUpdate();
    var yes_no = ($('#cart_note_leave:checked').length) ? 'Yes' : 'No';
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: 'attributes[Authority To Leave]='+ yes_no,
      dataType: "json",
      success : function(data) { 
        console.log('Cart Done');
      }
    });
  });

  $('.AddressZipNew').on("keyup change", function(e) {    
    $('.shipping_step').find('#address_zip_new').val($(this).val());
  });
  $('.AddressProvince').on("keyup change", function(e) {    
    $('.shipping_step').find('#address_province_new').val($(this).val());
  });

  $("body").on('click', ".popup-closer, .overlay", function(e){
    e.preventDefault();
    if (!$('.poup_position').hasClass("processing")) {
      var $parents = $('.popup-active').attr('data-popup');
      $(this).closest(".cs-popup").removeClass("popup-active");
      $('.overlay').removeClass("popup-active");
      $('.poup_position').removeClass("popup-active");
      $("body").removeClass("overflow_hidden");
      $('[name="checkout"]').removeAttr('disabled');
    }
  });

  $("body").on('click', '#go_to_the_gift', function(e){
    e.preventDefault();
    $('.shipping_step').hide();
    $('.gift_step').show();
  });

  $("body").on('click', '.back-btn', function(e){
    e.preventDefault();
    var cur = $(this).data('step');
    var next = $(this).parent().find('.next-btn').data('step');
    $('.process[data-step="'+next+'"]').hide();
    $('.process[data-step="'+cur+'"]').show();
  });

  $("body").on('click', '#submit_gift', function(e){
    e.preventDefault();
    var provinceCode = {
      "Australian Capital Territory": "ACT",
      "New South Wales": "NSW",
      "Northern Territory": "NT",
      "Queensland": "QLD",
      "South Australia": "SA",
      "Tasmania": "TAS",
      "Victoria": "VIC",
      "Western Australia": "WA"
    }
    var gift_number = $('#gift_number').val();
    var gift_date = $('#gift_month').val();
    var reg = new RegExp('^[0-9]*$');
    var email_or_phone = $('.address_edit_form_ajax input[name="address[email]"]').val();
    var first_name = $('.address_edit_form_ajax input[name="address[first_name]"]').val();
    var last_name = $('.address_edit_form_ajax input[name="address[last_name]"]').val();
    var address1 = $('.address_edit_form_ajax input[name="address[address1]"]').val();
    var address2 = $('.address_edit_form_ajax input[name="address[address2]"]').val();
    var city = $('.address_edit_form_ajax input[name="address[city]"]').val();
    var country = $('.address_edit_form_ajax select[name="address[country]"]').val();
    var province = $('.address_edit_form_ajax select[name="address[province]"]').val();
    var zip = $('.address_edit_form_ajax input[name="address[zip]"]').val();
    var phone = $('.address_edit_form_ajax input[name="address[phone]"]').val();
    normal_checkout = false;
    var x = true;
    $('.gift_step .errorMsg').html('');
    if(gift_number == '') {
      $('.gift_step .errorMsg').html('Please add the gift card number');
      x = false;
      return false;
    }
    if(!reg.test(gift_number)) {
      $('.gift_step .errorMsg').html('Please valid gift card number');
      x = false;
      return false;
    }
    if(gift_date == '') {
      $('.gift_step .errorMsg').html('Please select Expired Date');
      x = false;
      return false;
    }
    if(x == false){
      return false;
    }
    if (x == true) {
      if ((free_shipping == false && AIOD_discount == false) || (free_shipping == false && AIOD_discount == true)) {
        var shipping_name_first = $('[name="shipping_rates"]:checked').data('shipping-name');
        var shipping_price_first = Number($('[name="shipping_rates"]:checked').data('shipping-price').replace('$', '').replace('AUD', ''));
      } else if (free_shipping == true && AIOD_discount == true) {
        var shipping_name_first = free_shipping_name;
        var shipping_price_first = 0;
      }
      var formdata = {}, ship_form = $('.address_edit_form_ajax');
      var all_form_data = ship_form.serializeArray();
      $('#submit_gift').addClass('processing');
      $('#submit_netterm').attr('disabled','disabled');
      $('#submit_gift').attr('disabled','disabled');
      $('.ship_form_msg').remove();
      $(all_form_data).each(function(ii,vv){
        if(vv.name.indexOf('address[') > -1){
          var new_name = vv.name.replace('address[' , '');
          new_name = new_name.replace(']','');
          formdata[new_name] = vv.value;
        }
      });
      formdata['countryCode'] = 'AU';
      formdata['provinceCode'] = provinceCode[ship_form.find('[name="address[province]"]').val()];
      var is_gift = false;
      if (gift_number != '') {
        is_gift = true;
      }
      if (free_shipping == false && AIOD_discount == false) {
        var data = {
          cdata: window.update_cart_data,
          shipping_address: formdata,
          shop: window.prvt_apk_data.store_id,
          shipping_name: shipping_name_first,
          shipping_rate: shipping_price_first,
          voucher_number: gift_number,
          gift_card_expiry: gift_date,
          email_or_phone: email_or_phone
        };
      } else if ((free_shipping == true && AIOD_discount == true) || (free_shipping == false && AIOD_discount == true)) {
        var data = {
          cdata: window.update_cart_data,
          shipping_address: formdata,
          shop: window.prvt_apk_data.store_id,
          shipping_name: shipping_name_first,
          shipping_rate: shipping_price_first,
          voucher_number: gift_number,
          gift_card_expiry: gift_date,
          email_or_phone: email_or_phone,
          draft_order_id: draft_order_id
        };
      }
      console.log(window.update_cart_data);
      console.log(data);
      $.ajax({
        url: 'https://webapp.wheelandbarrow.com.au/api/create-draft-order',
        data: data,
        dataType: 'json',
        type: 'POST',
        crossDomain: true,
        success: function (result) {
          console.log('Success.......')
          console.log('result =', result);
          //                 return false;
          if(result.success){
            $('.netterm_submit').removeClass('processing');
            ship_form[0].reset();
            if (result.cart_clear == true) {
              $('.cs-popup').hide();
              $('.poup_position').addClass("processing");
              $('.netterm_popup-main').hide();
              $.post('/cart/clear', function(){
                window.location.href = result.redirect_url;
              })
            } else {
              // display redirecty to complate order for rest of amount
              $('.gift_step .errorMsg').html('You gift voucher amount is less...');
              setTimeout(function(){
                $('.cs-popup').hide();
                $('.poup_position').addClass("processing");
                $('.netterm_popup-main').hide();
                window.location.href = result.redirect_url+'?step=contact_information&checkout[email]='+email_or_phone+'&checkout[shipping_address][first_name]='+first_name+'&checkout[shipping_address][last_name]='+last_name+'&checkout[shipping_address][address1]='+address1+'&checkout[shipping_address][address2]='+address2+'&checkout[shipping_address][city]='+city+'&checkout[shipping_address][zip]='+zip+'&checkout[shipping_address][country]='+country+'&checkout[shipping_address][province]='+province+'&checkout[shipping_address][phone]='+phone;
              },1000);
            }

          } else {
            $('#submit_gift').removeClass('processing');
            $('.gift_step .errorMsg').html(result.message);
          }
          $('.netterm_submit').removeClass('processing');
          $('#submit_gift').removeAttr('disabled');
          $('#submit_netterm').removeAttr('disabled');
        },
        error: function (jqXHR, textStatus) {
          $('#submit_gift').removeClass('processing');
          $('.gift_step .errorMsg').html(textStatus);
          $('#submit_gift').removeAttr('disabled');
          $('#submit_netterm').removeAttr('disabled');
        }
      });
      return false;
    }
  });

  // note: this is not a drop-in solution yet, merely a demo, with an id instead of reusable class for the wrapper etc.
  const showOriginalFieldForDemo = true;

  // see https://codepen.io/Connum/pen/xxPVQQO?editors=0010
  // for detection

  const fieldDateOfBirth = document.getElementById('gift_month');
  if (fieldDateOfBirth) {
    let month_names = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];

    // use localized month names
    if ( window.Intl && window.Intl.DateTimeFormat ) {
      try {
        var formatter = new window.Intl.DateTimeFormat([], { month: 'long', timeZone: 'UTC' });
        var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => {
          var mm = month < 10 ? '0' + month : month;
          return new Date('0000-' + mm + '-01T00:00:00+00:00');
        });
        month_names = months.map(date => formatter.format(date));
      } catch(e) {}
    }

    const dateWrapper = document.createElement('div');
    dateWrapper.id = 'date-select-wrapper';
    fieldDateOfBirth.parentNode.appendChild(dateWrapper);

    const dateFieldDay = document.createElement('select');
    const dateFieldMonth = document.createElement('select');
    const dateFieldYear = document.createElement('select');

    const dateFields = [dateFieldYear, dateFieldMonth, dateFieldDay];

    const main_date = document.createElement('div');
    $(main_date).addClass('form-field-select-wrapper');
    const main_month = document.createElement('div');
    $(main_month).addClass('form-field-select-wrapper');
    const main_year = document.createElement('div');
    $(main_year).addClass('form-field-select-wrapper');

    // copy over styles from text input
    dateFields.forEach( function( f ) {
      $(f).addClass('form-field-input form-field-select form-field-filled');
    });

    const emptyDayOption = document.createElement('option');
    emptyDayOption.value = '';
    emptyDayOption.textContent = 'Day';
    dateFieldDay.add(emptyDayOption);
    const emptyMonthOption = document.createElement('option');
    emptyMonthOption.value = '';
    emptyMonthOption.textContent = 'Month';
    dateFieldMonth.add(emptyMonthOption);
    const emptyYearOption = document.createElement('option');
    emptyYearOption.value = '';
    emptyYearOption.textContent = 'Year';
    dateFieldYear.add(emptyYearOption);

    const dayOptions = [emptyDayOption];
    for ( var i = 1; i <= 31; i++ ) {
      var newOption = document.createElement('option');
      newOption.value = ( i < 10 ? '0' : '' ) + i;
      newOption.textContent = i;
      dayOptions.push( newOption );
      dateFieldDay.add( newOption );
    }

    const monthOptions = [emptyMonthOption];
    for ( var i = 0; i < month_names.length; i++ ) {
      var newOption = document.createElement('option');
      newOption.value = ( i < 9 ? '0' : '' ) + ( i + 1 );
      newOption.textContent = month_names[i];
      monthOptions.push(newOption);
      dateFieldMonth.add(newOption);
    }

    const yearStart = new Date().getFullYear();
    const yearEnd = yearStart + 8;
    const yearOptions = [emptyYearOption];
    for (var i = yearStart; i <= yearEnd; i++) {
      var newOption = document.createElement('option');
      newOption.value = i;
      newOption.textContent = i;
      yearOptions.push(newOption);
      dateFieldYear.add(newOption);
    }

    var svg = '<svg aria-hidden="true" focusable="false" role="presentation" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-chevron-down"><path class="icon-chevron-down-left" d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path><path class="icon-chevron-down-right" d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path></svg>'

    //     $(dateFieldDay).val('14').trigger('change');
    //     $(dateFieldMonth).val('01').trigger('change');
    //     $(dateFieldYear).val('2024').trigger('change');
    main_date.append(dateFieldDay);
    main_month.append(dateFieldMonth);
    main_year.append(dateFieldYear);
    $(main_date).append('<label class="form-field-title">Date</label>');
    $(main_month).append('<label class="form-field-title">Month</label>');
    $(main_year).append('<label class="form-field-title">Year</label>');
    $(main_date).append(svg);
    $(main_month).append(svg);
    $(main_year).append(svg);

    dateWrapper.appendChild(main_date);
    dateWrapper.appendChild(main_month);
    dateWrapper.appendChild(main_year);

    const dateChangeHandler = function() {
      // var day = parseInt( dateFieldDay.value, 10 );
      const month = parseInt( dateFieldMonth.value, 10 );
      const year = parseInt( dateFieldYear.value, 10 );
      let maxDays = 31;

      if ( month === 2 ) {
        const isLeapYear = ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)
        maxDays = isLeapYear ? 29 : 28;
      } else if ( [2, 4, 6, 9, 11].indexOf( month ) >= 0 ) {
        maxDays = 30;
      }

      dayOptions.filter(function( o, i ) {
        o.hidden = i > maxDays;
        if ( o.hidden && o.selected ) {
          emptyDayOption.selected = true;
        }
      });

      let allSet = true;
      dateFields.forEach(field => {
        const isEmpty = ! field.value;
        if ( isEmpty ) {
          allSet = false;
        }
        field.classList[isEmpty ? 'add' : 'remove']('show-placeholder');
      });

      if ( allSet ) {
        fieldDateOfBirth.value = dateFields.map(function(field) {
          return field.value;
        }).join('-');
      } else {
        fieldDateOfBirth.value = '';
      }
    };

    // if the original input already has a value, set the selected options accordingly
    if ( fieldDateOfBirth.value ) {
      const ymd = fieldDateOfBirth.value.split('-');
      yearOptions.filter(function(o) {
        if ( o.value === ymd[0]) {
          o.selected = true;
        }
      });
      monthOptions[parseInt(ymd[1], 10)].selected = true;
      dayOptions[parseInt(ymd[2], 10)].selected = true;
    }

    dateFieldDay.addEventListener( 'change', dateChangeHandler );
    dateFieldMonth.addEventListener( 'change', dateChangeHandler );
    dateFieldYear.addEventListener( 'change', dateChangeHandler );
    dateChangeHandler();

    // do this last, so in case anything throws an error, we still have the input as a fallback
    if ( ! showOriginalFieldForDemo ) {
      fieldDateOfBirth.type = 'hidden';
    }
  }

  //cart attributes edit
  $.ajax({
    type: "POST",
    url: "/cart/update.js?csapp=aiod",
    data: 'attributes[Authority To Leave]=Yes',
    dataType: "json",
    success : function(data) {  } });
}); 